export const toPrecision = (number: number, decimal: number = 2) => {
    const maxPrecision = +(+number || 0).toFixed(10); // required to avoid weird JS calculations
    const factor = Math.pow(10, decimal || 0);
    return +(Math.round(maxPrecision * factor) / factor).toFixed(decimal || 0);
};

export const getDiscounted = (value: number, discount: number) =>
    toPrecision((value ?? 0) * (1 - (discount ?? 0) / 100), 2);
